// import axios from 'axios'
import axios from '../../helpers/Axios'

export const subsectormodule = {

	namespaced: true,

	state: {

		allSubSectors: []
	},
	getters: {

		allSubSectors: state => { return state.allSubSectors; }
	},
	actions: {

		getSubSectors({ commit }) {
			return axios.get('/SubSector').then(response => {

				commit('allSubSectors', response.data);

			}).catch(err => {
				console.log(err);
			});
		}
	},
	mutations: {

		allSubSectors(state, subSectors) {
			state.allSubSectors = subSectors
		}
	}
}
